import React, { useState } from 'react';
import Styles from './BannerCanaisAtendimento.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function BannerCanaisAtendimento() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="canais-de-atendimento-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 320 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/canais-de-atendimento/hero/banner-320.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/canais-de-atendimento/hero/banner-320.png"
                  />
                  <img
                    src="assets/canais-de-atendimento/hero/banner-320.png"
                    alt="Mulher branca pesquisando no celular sobre os canais de atendimento do Santander."
                  />
                </picture>
              )}
              {width > 320 && width <= 450 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/canais-de-atendimento/hero/banner-450.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/canais-de-atendimento/hero/banner-450.png"
                  />
                  <img
                    src="assets/canais-de-atendimento/hero/banner-450.png"
                    alt="Mulher branca pesquisando no celular sobre os canais de atendimento do Santander."
                  />
                </picture>
              )}
              {width > 450 && width <= 800 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/canais-de-atendimento/hero/banner-800.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/canais-de-atendimento/hero/banner-800.png"
                  />
                  <img
                    src="assets/canais-de-atendimento/hero/banner-800.png"
                    alt="Mulher branca pesquisando no celular sobre os canais de atendimento do Santander."
                  />
                </picture>
              )}
              {width > 800 && width <= 1280 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/canais-de-atendimento/hero/banner-1280.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/canais-de-atendimento/hero/banner-1280.png"
                  />
                  <img
                    src="assets/canais-de-atendimento/hero/banner-1280.png"
                    alt="Mulher branca pesquisando no celular sobre os canais de atendimento do Santander."
                  />
                </picture>
              )}
              {width > 1280 && width <= 1360 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/canais-de-atendimento/hero/banner-1360.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/canais-de-atendimento/hero/banner-1360.png"
                  />
                  <img
                    src="assets/canais-de-atendimento/hero/banner-1360.png"
                    alt="Mulher branca pesquisando no celular sobre os canais de atendimento do Santander."
                  />
                </picture>
              )}
              {width > 1360 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/canais-de-atendimento/hero/banner-1440.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/canais-de-atendimento/hero/banner-1440.png"
                  />
                  <img
                    src="assets/canais-de-atendimento/hero/banner-1440.png"
                    alt="Mulher branca pesquisando no celular sobre os canais de atendimento do Santander."
                  />
                </picture>
              )}
            </>
          )}
        </div>
        {/* <div className="fade-banner" /> */}
        {/* <div className="fade-banner-gradiente" /> */}
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Canais de atendimento</h1>
              <p className="alt-text">
                Conheça os serviços e todas as facilidades que você encontra na Santander
                Financiamentos. Confira também nossos canais oficiais de contato.
              </p>
              {/* <WhiteButton
                href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento:banner&int_campaign=consultar"
                rel="noopener"
                target="_blank"
                className="btn-simulate"
              >
                Consultar
              </WhiteButton> */}
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default BannerCanaisAtendimento;
